
import { defineComponent, onMounted, reactive, ref } from "vue";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { getCSSVariableValue } from "@/assets/ts/_utils";
import { watch } from "vue";
import { convertToMoney } from "@/utils/stringUtils";
import ApexCharts from "apexcharts";
import { useStore } from "vuex";
/* import { Home } from "@/store/enums/StoreEnums"; */

interface DataForm {
  cEmail: string | null;
  fullName: string | null;
  cMatKhau: string | null;
  cQuyenHeThong: string | null;
  cSoDienThoai: string | null;
  cTenNhomQuyen: string | null;
  cTenTaiKhoan: string | null;
  compIdArray: Array<string | number | null> | null;
  compNameArray: Array<string | null> | null;
  confirmPassword: string | null;
  nMaCongTy: string | null;
  nMaNhomQuyen: string | number | null;
  nMaTaiKhoan: string | null;
  nTinhTrang: string | null;
}

interface Data {
  nTongDoanhThu: number;
  nTongDongHo: number;
  nTongDongHoMoi: number;
  nTongTieuThu: number;
}

export default defineComponent({
  name: "widget-1",
  props: {
    widgetClasses: String,
    widgetColor: String,
    strokeColor: String,
    dataString: String,
  },
  setup(props) {
    const labelColor = getCSSVariableValue("--bs-gray-500");
    const borderColor = getCSSVariableValue("--bs-gray-200");

    const color = getCSSVariableValue("--bs-" + props.widgetColor);

    const strokeColor = ref(props.strokeColor);

    const chart = ref<ApexCharts>();
    const store = ref(useStore());

    const dataForm: DataForm = {
      cEmail: null,
      fullName: null,
      cMatKhau: null,
      cQuyenHeThong: null,
      cSoDienThoai: null,
      cTenNhomQuyen: null,
      cTenTaiKhoan: null,
      compIdArray: null,
      compNameArray: null,
      confirmPassword: null,
      nMaCongTy: null,
      nMaNhomQuyen: null,
      nMaTaiKhoan: null,
      nTinhTrang: null,
    };
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const chartOptions = {
      chart: {
        fontFamily: "inherit",
        type: "area",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        sparkline: {
          enabled: true,
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: undefined,
          top: 5,
          left: 0,
          blur: 3,
          color: strokeColor.value,
          opacity: 0.5,
        },
      },
      plotOptions: {},
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: "solid",
        opacity: 0,
      },
      stroke: {
        curve: "smooth",
        show: true,
        width: 3,
        colors: [strokeColor.value],
      },
      xaxis: {
        categories: [""],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          style: {
            colors: labelColor,
            fontSize: "12px",
          },
        },
        crosshairs: {
          show: false,
          position: "front",
          stroke: {
            color: borderColor,
            width: 1,
            dashArray: 3,
          },
        },
      },
      yaxis: {
        labels: {
          show: false,
          style: {
            colors: labelColor,
            fontSize: "12px",
          },
        },
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: "12px",
        },
        y: {
          formatter: function (value) {
            // Customize the tooltip content here
            return "‎" + convertToMoney(value) + " đ";
          },
        },
        marker: {
          show: true,
        },
      },
      markers: {
        colors: [color],
        strokeColor: [strokeColor.value],
        strokeWidth: 3,
      },
    };

    const series = reactive([
      {
        name: "Net Profit",
        data: [0],
      },
    ]);
    const data = ref<Data>({} as Data);

    onMounted(() => {
      MenuComponent.reinitialization();
    });

    return {
      store,
      series,
      chartOptions,
      dataForm,
      chart,
      months,
      data,
    };
  },
  methods: {
    handleNumber(val) {
      return convertToMoney(val);
    },
    handleData(val) {
      if (val && val != "[]") {
        let data = JSON.parse(val as string);
        let array = [] as number[];
        let month = [] as string[];
        for (let i = 0; i < data.length; i++) {
          array.push(data[i].nTongTien as number);

          month.push(this.months[parseInt(data[i].cThang.split("/")[1]) - 1]);
        }
        this.series[0].data = array;
        this.chart?.updateOptions({
          xaxis: {
            categories: month,
          },
        });
      }
    },
   /*  handleGetTop4() {
      this.store.dispatch(Home.findDTBanGoi).then((res) => {
        if (res.code == 200) {
          this.data = res.data;
        }
      });
    }, */
  },
  mounted() {
    this.handleData(this.$props.dataString);
    /* this.handleGetTop4(); */
    watch(
      () => this.$props.dataString,
      (newData) => {
        this.handleData(newData);
      }
    );
  },
});
